// extracted by mini-css-extract-plugin
module.exports = {"root":"TableCell_root__1xXyw","highlighter":"TableCell_highlighter__HrVax","icon":"TableCell_icon__2RIf-","amount":"TableCell_amount__2PiWl"};